export enum Dataset {
    MissingStops = 'missingStops',
    LateArrivals = 'lateArrivals',
}
